import React, { useState, useEffect } from "react";
import "../assets/styles/main.scss";

const Preloader = ({ useLocalStorage = true }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isFirstVisit, setIsFirstVisit] = useState(true);

  // Variables de délai
  const preloaderDuration = 4470; // Durée du préloader en millisecondes
  const loopSoundStartDelay = 1000; // Délai avant de lancer le second son en millisecondes

  useEffect(() => {
    let timer;

    if (useLocalStorage) {
      const firstVisit = localStorage.getItem("isFirstVisit");
      if (firstVisit) {
        setIsFirstVisit(false);
        setIsLoading(false);
        document.body.classList.remove("preloader-active");
        document.body.classList.add("preloader-complete");
        return;
      }
    }

    document.body.classList.add("preloader-active");
    timer = setTimeout(() => {
      setIsLoading(false);
      document.body.classList.remove("preloader-active");
      document.body.classList.add("preloader-complete");
      if (useLocalStorage) {
        localStorage.setItem("isFirstVisit", "false");
      }
    }, preloaderDuration);

    return () => {
      clearTimeout(timer);
      document.body.classList.remove("preloader-active");
      document.body.classList.add("preloader-complete");
    };
  }, [useLocalStorage, preloaderDuration]);

  useEffect(() => {
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    let preloaderBuffer, loopBuffer;
    let preloaderSource, loopSource;

    const loadSound = (url) => {
      return fetch(url)
        .then((response) => response.arrayBuffer())
        .then((arrayBuffer) => audioContext.decodeAudioData(arrayBuffer))
        .catch((error) => {
          console.error("Erreur lors du décodage des données audio:", error);
        });
    };

    const playSound = (buffer, loop = false, delay = 0) => {
      const source = audioContext.createBufferSource();
      source.buffer = buffer;
      source.loop = loop;
      source.connect(audioContext.destination);
      source.start(audioContext.currentTime + delay);
      return source;
    };

    const playIntroSound = () => {
      console.log("Lecture du son de préchargement...");
      preloaderSource = playSound(preloaderBuffer);
      preloaderSource.onended = () => {
        // Play the looping sound after the intro sound ends
        console.log("Lecture du son en boucle...");
        loopSource = playSound(loopBuffer, true);
      };
    };

    Promise.all([
      loadSound(
        "https://sybf.fr/wp-content/themes/sybf/src/assets/sounds/preloader/intro-start.mp3"
      ),
    ])
      .then(([introBuffer, roomBuffer]) => {
        preloaderBuffer = introBuffer;
        loopBuffer = roomBuffer;
        if (isLoading) {
          playIntroSound();
        } else {
          console.log("Lecture du son en boucle...");
          loopSource = playSound(loopBuffer, true);
        }
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des sons:", error);
      });

    return () => {
      if (preloaderSource) preloaderSource.stop();
      if (loopSource) loopSource.stop();
      audioContext.close();
    };
  }, [isLoading, preloaderDuration, loopSoundStartDelay]);

  return (
    <div className={`preloader ${isLoading ? "active" : "inactive"}`}>
      <div className="overlay"></div>
      <img
        className="logo"
        src="https://sybf.fr/wp-content/themes/sybf/src/assets/img/logo.png"
        alt="logo"
      />
      <img
        className="vb-text img-title"
        src="https://sybf.fr/wp-content/themes/sybf/src/assets/img/titre_blanc.png"
        alt="title"
      />
    </div>
  );
};

export default Preloader;
